// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trip-info-modal-wrapper {
  display: flex;
  gap: 30px;
  width: 83vw;
  height: 80vh;
}
.trip-info-modal-wrapper .trip-info-side-section {
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.trip-info-modal-wrapper .trip-info-main-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.trip-info-modal-wrapper .trip-info-main-section .header-wrapper {
  width: 94%;
  border: 1px solid #ddd;
  padding: 10px 20px;
  border-radius: 6px;
  margin-right: 66px;
}
.trip-info-modal-wrapper .trip-info-main-section .header-wrapper p {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}
.trip-info-modal-wrapper .trip-info-main-section .header-wrapper div {
  display: flex;
  gap: 10px;
}
.trip-info-modal-wrapper .trip-info-main-section .body-wrapper {
  height: 70vh;
  max-width: 70vw;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
  overflow: auto;
}
.trip-info-modal-wrapper .trip-info-main-section .body-wrapper .itinerary-heading-1, .trip-info-modal-wrapper .trip-info-main-section .body-wrapper .itinerary-heading-2, .trip-info-modal-wrapper .trip-info-main-section .body-wrapper .cabin-heading {
  font-size: 20px;
  font-weight: 500;
  color: #3a3a3a;
}
.trip-info-modal-wrapper .trip-info-main-section .body-wrapper .itinerary-heading-1 {
  width: 97px;
  padding: 0 10px;
}
.trip-info-modal-wrapper .trip-info-main-section .body-wrapper .itinerary-heading-2 {
  display: inline-block;
  width: 70%;
  text-align: center;
}
.trip-info-modal-wrapper .trip-info-main-section .body-wrapper .cabin-heading {
  font-size: 18px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ItineraryInfoModal/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAAJ;AAEI;EACE,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAAN;AAEM;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAAR;AAGM;EACE,aAAA;EACA,SAAA;AADR;AAKI;EACE,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAHN;AAKM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAHR;AAMM;EACE,WAAA;EACA,eAAA;AAJR;AAOM;EACE,qBAAA;EACA,UAAA;EACA,kBAAA;AALR;AAQM;EACE,eAAA;EACA,gBAAA;AANR","sourcesContent":[".trip-info-modal-wrapper{\n  display: flex;\n  gap: 30px; \n  width: 83vw;\n  height: 80vh;\n\n  .trip-info-side-section{\n    width: fit-content;   \n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .trip-info-main-section{\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n\n    .header-wrapper{\n      width: 94%;\n      border: 1px solid #ddd;  \n      padding: 10px 20px;\n      border-radius: 6px;\n      margin-right: 66px;\n\n      p{\n        font-size: 20px;\n        font-weight: 700;\n        letter-spacing: 0.03em; \n        margin-bottom: 10px;\n      }\n\n      div{\n        display: flex;\n        gap: 10px;\n      }\n    }\n\n    .body-wrapper{\n      height: 70vh;\n      max-width: 70vw;\n      border: 1px solid #ddd;\n      border-radius: 6px;\n      padding: 20px;\n      overflow: auto;\n\n      .itinerary-heading-1, .itinerary-heading-2, .cabin-heading{\n        font-size: 20px;\n        font-weight: 500;\n        color: #3a3a3a;\n      }\n\n      .itinerary-heading-1{\n        width: 97px;\n        padding: 0 10px;\n      }\n\n      .itinerary-heading-2{\n        display: inline-block;\n        width: 70%;\n        text-align: center;\n      }\n\n      .cabin-heading{\n        font-size: 18px;\n        font-weight: 700;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
